import React, { useEffect, useState } from "react";
import FloorplanSelectControl from "./FloorplanSelectControl";
import FloorplanOverlay from "./FloorplanOverlay";
import api from "../../api";
import { useMap } from "@vis.gl/react-google-maps";
import useCommonMap from "../../hooks/useCommonMap";

const CommonMapFloorplans = ({
  mode,
  // onSelectedFloorplanChanged,
  onSelectedGeometryChanged,
  children,
}) => {
  // const [selectedFloorplan, setSelectedFloorplan] = useState(null);
  // const [floorplanImage, setFloorplanImage] = useState(null);
  // const map = useMap();

  const commonMap = useCommonMap();
  const {
    selectedFloorplan,
    setSelectedFloorplan,
    floorplanImage,
    setFloorplanImage,
    current,
    setCurrent,
  } = commonMap;

  useEffect(() => {
    if (selectedFloorplan) {
      getFloorplanImage(selectedFloorplan.id);
    } else {
      setFloorplanImage(null);
    }

    return () => {
      setFloorplanImage(null);
      // map && map.overlayMapTypes.clear();
      // map && map.data.forEach((feature) => map.data.remove(feature));
      // map && map.setHeading(0);
      // map && map.data.setStyle(null);
      // map && map.data.setMap(null);
      // map && map.close();
      // map && map.unbindAll();
      // map && map = null;
    };
  }, [selectedFloorplan]);

  const getFloorplanImage = (id) => {
    api
      .get(`files/floorplans/${id}`, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        let blob = new Blob([res.data], { type: "img/jpeg" });
        let url = (window.URL || window.webkitURL).createObjectURL(blob);
        setFloorplanImage(url);
      })
      .catch(() => setFloorplanImage(null));
  };

  // const handleSelect = (selectedFloorplan) => {
  //   setSelectedFloorplan(selectedFloorplan);
  //   onSelectedFloorplanChanged && onSelectedFloorplanChanged(selectedFloorplan);
  //   // getFloorplanImage(selectedFloorplan.id);
  // };

  if (
    mode !== "view" &&
    mode !== "edit" &&
    mode !== "geofence" &&
    mode !== "readerview"
  ) {
    return <React.Fragment>{children}</React.Fragment>;
  } else {
    return (
      <React.Fragment>
        <FloorplanSelectControl
          // showDefault={mode !== "geofence" && mode !== "readerview"}
          showMap={mode === "geofence" || mode === "readerview"}
          // asset={current?.id ?? null}
          // onSelect={handleSelect}
          right={mode === "view" || mode === "readerview"}
        />
        <FloorplanOverlay
          mode={mode}
          img={floorplanImage}
          curFloor={selectedFloorplan}
          setSelectedGeometry={(g) => {
            onSelectedGeometryChanged && onSelectedGeometryChanged(g);
          }}
          rotate={selectedFloorplan?.rotation || 0}
          // selectedGeometry={selectedGeometry}
          // setSelectedGeometry={setSelectedGeometry}
          setPosition={() => {}}
          setPosition1={() => {}}
        />
        {children}
      </React.Fragment>
    );
  }
};

export default CommonMapFloorplans;
